<template>

	<EditUserPopup :user="user" :isOpen="EditIsOpen" @update:isOpen="EditIsOpen = $event" ref="userPopupForm"/>

	<div class="container-fluid container-temperature">

    <div class="col-12 tab-content">
      <transition name="fade" mode="out-in">

        <table class="table" v-if="!this.loading && employees && employees.employees">
          <thead>
          <tr>
            <th>nickname</th>
            <th>სახელი</th>
            <th>გვარი</th>
            <th>ელ-ფოსტა</th>
            <th>ტელეფონი</th>
            <th>ქმედება</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="employee in employees.employees" v-bind:key="employee.nickname">
            <td>{{employee.nickname}}</td>
            <td>{{employee.name}}</td>
            <td>{{employee.surname}}</td>
            <td>{{employee.email}}</td>
            <td>{{employee.tel}}</td>
            <td>
							<img src="/svgs/edit2.svg" @click.prevent="showEditUser(employee.nickname);" alt="">
						</td>
          </tr>
          </tbody>
        </table>
      </transition>
    </div>
  </div>

</template>

<script>
import useVuelidate from "@vuelidate/core";
import LoaderItem from "@/components/partials/LoaderItem";
import AddAlertPopup from "@/components/alert/AddAlertPopup.vue";
import EditUserPopup from "@/components/profile/EditUserPopup.vue";

export default {
	name: 'UsersItem',
	components: { EditUserPopup, AddAlertPopup, LoaderItem },
	computed: {
		employees() {
			return this.$store.state.user.employees.data;
		},
		user() {
			return this.$store.state.user.employee;
		}
	},
	methods: {
		showEditUser(nickname) {
			let params = {
				nickname: nickname
			};
			this.$store.dispatch('user/getData', params).then(() => {
				this.EditIsOpen = true;
			});
		}
	},
	setup() {
		return { v$: useVuelidate() }
	},
	data() {
		return {
			loading: true,
			EditIsOpen: false,
		}
	},
	mounted() {
		this.$store.dispatch('user/users').then(() => {
			this.loading = false;
		});
		this.$store.dispatch('user/getPermissions').then(() => {
			this.loading = false;
		});
	}
}
</script>

<style scoped>



.week-col{
  width: 22.2%;
}

.container-temperature{
  padding-left: 0;
  padding-right: 0;
}

.tab-header{
  padding:15px
}

.form-group:not(:first-child){
  margin-left: 10px;
}









.input-group-text{
  border: 1px solid var(--dropzone-border);
  background: #ffffff;
}



.no-padding{
  padding: 5px;
}


.vs__dropdown-toggle{
  height: 100% !important;
  border: 1px solid var(--dropzone-border) !important;
  min-width: 100px;
}

.vs__search{
  display: block !important;
  padding: .11rem 0 !important;
}


.addon-select > .vs__dropdown-toggle{
  border: 1px solid var(--dropzone-border);
  border-left: 0 !important;
  border-radius: 0;
  border-right: 0;
}

 .second-addon-select > .vs__dropdown-toggle{
   border-left: 0 !important;
   border-right: 1px solid var(--dropzone-border);
   border-top-right-radius: 5px !important;
   border-bottom-right-radius: 5px !important;
 }

 .form-control{
   border: 1px solid var(--dropzone-border);
 }

 .red{
   border-radius: 5px;
   border: 1px solid red !important;
 }

.splash-screen-child{
  position: relative !important;
  padding-top: 5% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
}

.input-group-text.active-week{
  background: var(--submit-button-bg) !important;
  color: #ffffff !important;
}

.table{
  margin-top:20px;
  padding-top:5%;
  color:var(--second-titles);
  font-family: "TBCDinNusxuri-Medium";
  font-size: 16px;
}
.table > :not(:first-child){
  border: 1px solid var(--border-color) !important;
}
.table tbody tr:last-child{
  border: transparent;
}
.table tbody tr:hover{
  background: var(--hover-item);
  cursor: pointer;
}

.table > thead{
  vertical-align: middle;
  color: var(--text-sub-bold-color);
}

.table > :not(:first-child){
  border-top: 1px solid var(--border-color);
}

.table td:first-child, table th:first-child{
  padding-left: 20px;
}

.no-padding-div{
  padding-left: 5px;
  padding-right: 5px;
}

</style>